@if (isAppReady$ | ngrxPush) {
    <router-outlet></router-outlet>
} @else {
    <div
        class="bg-body position-fixed h-100 w-100 d-flex align-items-center justify-content-center"
    >
        <wdx-spinner></wdx-spinner>
    </div>
}

<wdx-toast></wdx-toast>
